// extracted by mini-css-extract-plugin
module.exports = {"about":"page_about__WuQPe","paragraph":"page_paragraph__ZRwtt","smallImage":"page_smallImage__meF9q","image":"page_image__j_abP"};